import React from 'react';
import PropTypes from 'prop-types';
import Background from 'components/common/Background';
import { Card, Col, Row, Container } from 'react-bootstrap';
import { Link, Outlet } from 'react-router-dom';
import VerticalLogo from 'components/common/VerticalLogo';

const AuthSplitLayout = ({ children, bgProps }) => {
  return (
    <Container fluid>
      <Row className="min-vh-100 bg-100">
        <Col xs={6} className="d-none d-lg-block position-relative">
          {bgProps && <Background {...bgProps} />}
        </Col>
        <Col
          sm={10}
          md={6}
          className="px-sm-0 d-flex align-items-center mx-auto justify-content-center py-5"
        >
          <div style={{ maxWidth: '500px' }}>
            <Link
              to={process.env.REACT_APP_CLIENT}
              style={{ textDecoration: 'none' }}
            >
              <VerticalLogo className="fs-4 z-index-1 position-relative w-50 mb-3" />
            </Link>

            <Card className="mt-3 bg-ligh rounded">
              <Card.Body className="p-4">{children || <Outlet />}</Card.Body>
            </Card>

            <Row>
              <Col>
                <p className="text-center my-4 small">
                  <span className="fw-bold d-block">CUCICBA</span>
                  (Colegio Único de Corredores Inmobiliarios de la Ciudad de
                  Buenos Aires)
                  <br />
                  <hr />
                  <span className="d-block mb-2">
                    Adolfo Alsina 1382 - 1088 AAJ - CABA
                  </span>
                  Tel.: 4124-6060 <br />
                  <span className="fw-bolder">Horario de Atención:</span> Lunes
                  a Jueves de 9 a 18 hs. y Viernes de 9 a 17 hs. <br />
                  <a
                    href="http://www.colegioinmobiliario.org.ar"
                    target="_blank"
                    className="mb-2"
                    rel="noreferrer"
                  >
                    www.colegioinmobiliario.org.ar
                  </a>
                </p>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

AuthSplitLayout.propTypes = {
  children: PropTypes.node,
  bgProps: PropTypes.shape(Background.propTypes).isRequired
};

export default AuthSplitLayout;
